import text from './text.json'
import {applyVoucher, setButtonIsDisabled} from '../../stores/voucher'
import {handleFormChanges} from '../../utils/forms'
import {useSelector, useDispatch} from 'react-redux'
import {PageTitle, PageSubTitle, ResponsivePageTitle} from '../../components/core/title'
import {Formik} from 'formik'
import {voucherSchema} from '../../utils/validation'
import Input from '../../components/core/input'
import Footer from '../../components/layouts/footer'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import classNames from 'classnames'
import {trimStringValues} from '../../utils/text'

const ApplyVoucher = () => {
    const showLoader = useSelector(state => state.voucher.showLoader)
    const buttonIsDisabled = useSelector(state => state.voucher.buttonIsDisabled)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()
    const initialFormValues = {
        code: localStorage.getItem('voucher')
    }
    const sendVoucherCode = values => {
        dispatch(applyVoucher(trimStringValues(values)))
        dispatch(setButtonIsDisabled(true))
    }
    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <Formik
                        initialValues={initialFormValues}
                        onSubmit={sendVoucherCode}
                        validationSchema={voucherSchema}
                        validateOnBlur={false}
                        validateOnChange={false}>
                        {({values, errors, setFieldValue, handleSubmit}) => (
                            <form onSubmit={handleSubmit} className="form-elements">
                                <Input
                                    value={values.code}
                                    placeholder={text.voucher_code}
                                    infoText={text.voucher_code_info}
                                    name="code"
                                    onChange={e => dispatch(setButtonIsDisabled(handleFormChanges(e, 'code', setFieldValue, initialFormValues)))}
                                    error={errors.code}
                                />
                                <SimpleBlueButton disabled={buttonIsDisabled}
                                    type="submit">
                                    {showLoader && <ButtonLoader/>}
                                    {text.apply_voucher}
                                </SimpleBlueButton>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
            <Footer/>
        </main>
    )
}

export default ApplyVoucher
